import { render, staticRenderFns } from "./delete-option-modal.vue?vue&type=template&id=6b79cfd8&scoped=true&"
import script from "./delete-option-modal.vue?vue&type=script&lang=js&"
export * from "./delete-option-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79cfd8",
  null
  
)

export default component.exports